import { Phone, ListFilter } from 'lucide-react';

/**
 * Sticky bottom action bar on mobile. Big phone CTA + secondary
 * filter trigger. Hidden on md+.
 *
 *   <MobileCTABar phone="1-833-INJURY-1" onFilterClick={openFilters} />
 */

export interface MobileCTABarProps {
    phone: string;
    onFilterClick?: () => void;
    filterCount?: number;
    className?: string;
}

function telHref(number: string): string {
    return 'tel:' + number.replace(/[^0-9+]/g, '');
}

export function MobileCTABar({
    phone,
    onFilterClick,
    filterCount,
    className,
}: MobileCTABarProps) {
    const cls = [
        'fixed bottom-0 inset-x-0 z-30 md:hidden',
        'flex items-center gap-2 p-3',
        'bg-card border-t border-rule shadow-pop',
        className ?? '',
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <div className={cls} role="region" aria-label="Quick actions">
            {onFilterClick !== undefined && (
                <button
                    type="button"
                    onClick={onFilterClick}
                    className="inline-flex items-center gap-2 h-11 px-3.5 rounded-md border border-rule text-ink-soft hover:border-ink-soft text-[14px] cursor-pointer"
                >
                    <ListFilter size={16} aria-hidden="true" />
                    <span>Filter</span>
                    {filterCount !== undefined && filterCount > 0 && (
                        <span className="inline-flex items-center justify-center min-w-5 h-5 px-1 rounded-full bg-ember text-paper text-[11px] font-mono">
                            {filterCount}
                        </span>
                    )}
                </button>
            )}
            <a
                href={telHref(phone)}
                aria-label={`Call ${phone}`}
                className="flex-1 inline-flex items-center justify-center gap-2 h-11 px-4 rounded-md bg-ember text-paper font-medium text-[15px] no-underline"
            >
                <Phone size={16} aria-hidden="true" />
                <span>Call {phone}</span>
            </a>
        </div>
    );
}

export default MobileCTABar;
